import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSortModule } from '@angular/material/sort';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ScenarioTableComponent } from './scenario-table.component';
import {MatIconModule} from '@angular/material/icon';

@NgModule({
  declarations: [ScenarioTableComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatTableModule,
    MatTooltipModule,
    MatSortModule,
    MatRippleModule,
    MatPaginatorModule,
    RouterLink,
    MatIconModule,
  ],
  exports: [ScenarioTableComponent],
})
export class ScenarioTableModule {}
